// init collection swipers and variant pickers
function initCollectionVariantCategorySwipers() {
    document.querySelectorAll('.swiper').forEach(function(swiper) {
        initializeSwiper(swiper)
        initializeSwiperPickers(swiper);
    });
}

function initializeSwiper(swiper){
    // totalSlides = the number of the product's variants
    const totalSlides = parseInt(swiper.dataset.blocks);
    if(totalSlides == 0){
        // No variants
        return;
    }
    return new Swiper(`.swiper-variants-${swiper.dataset.product}`, {
        slidesPerView: Math.min(3, totalSlides),
        watchOverflow: true,
        navigation: {
            nextEl: `.swiper-variants-${swiper.dataset.product} .swiper-button-next`,
            prevEl: `.swiper-variants-${swiper.dataset.product} .swiper-button-prev`,
        }
    });
}

function initializeSwiperPickers(swiper){
    const variantPickers = swiper.querySelectorAll('.variant-category-picker');
    variantPickers.forEach(picker => {
        picker.addEventListener('click', () => {
            removePickersBorders(variantPickers);
            addSelectedPickerBorder(picker);
            changeProductImage(picker);
            changeProductFormInfo(picker);            
        })
    });
}

function removePickersBorders(variantPickers){
    variantPickers.forEach(picker => {
        const productImage = picker.querySelector('img');
        productImage.classList.remove('border-1');
    });
}

function changeProductImage(picker){
    const productImage = picker.closest('.product-block').querySelector('.image__primary img');
    const pickerImage = picker.dataset.image;
    if(productImage && pickerImage){
        productImage.src = pickerImage;
    }
}

function changeProductFormInfo(picker){
    const productFormWrapper = picker.closest('.collection-variant-category-wrapper');
    productFormWrapper.querySelector('.variant-id-form-input').value = picker.dataset.variant
    productFormWrapper.querySelector('.theme-money').innerText = picker.dataset.price
}

function addSelectedPickerBorder(picker){
    picker.querySelector('img').classList.add('border-1');
}


// init product swipers and variant pickers
function initProductVariantCategorySwipers() {
    document.querySelectorAll('.swiper').forEach(function(swiper) {
        const totalSlides = parseInt(swiper.dataset.blocks);
        if (totalSlides > 1) {
            new Swiper(`.swiper-variants-${swiper.dataset.product}`, {
                loop: false,
                autoplay: false,
                centeredSlides: true,
                slidesPerView: totalSlides > 5 ? 5 : totalSlides,
                watchOverflow: true,
                allowTouchMove: false,
                navigation: {
                    nextEl: `.swiper-variants-${swiper.dataset.product} .swiper-button-next`,
                    prevEl: `.swiper-variants-${swiper.dataset.product} .swiper-button-prev`,
                },
                freeMode: {
                    enabled: false
                  },
                breakpoints: {
                    768: {
                        loop: false,
                        autoplay: false,
                        centeredSlides: true,
                        slidesPerView: totalSlides > 4 ? 4 : totalSlides,
                        watchOverflow: true,
                        allowTouchMove: false,
                        navigation: {
                            nextEl: `.swiper-variants-${swiper.dataset.product} .swiper-button-next`,
                            prevEl: `.swiper-variants-${swiper.dataset.product} .swiper-button-prev`,
                        },
                    }
                }
            });
        }
    });
}